import io from "socket.io-client";
import { baseUrlSocket } from "../../networking/api";
const SOCKET_URL = baseUrlSocket;

class WSService {
  [x: string]: any;
  initializeSocket = async () => {
    try {
      this.socket = io(SOCKET_URL, {
        transports: ["websocket"],
        reconnection: true,
        reconnectionDelay: 500,
        reconnectionAttempts: Infinity,
      });
    

      this.socket.on("connect", (data: any) => {
      });

      this.socket.on("disconnect", (data: any) => {
      });

      this.socket.on("error", (data: any) => {
      });
    } catch (error) {
      console.error("socket is not initialized", error);
    }
  };
  socket: any;

  emit(event: any, data = {}) {
    this.socket.emit(event, data);
  }
  on(event: any, cb: any) {
    this.socket.on(event, cb);
  }
  removelistener(listenerName: any) {
    this.socket.removelistener(listenerName);
  }
}

const socketServices = new WSService();
export default socketServices;
